export function isEqual(value1: any, value2: any): boolean {
  if (typeof value1 !== 'object' && typeof value2 !== 'object') {
    return value1 === value2;
  }

  return JSON.stringify(value1) === JSON.stringify(value2);
}
